export default __webpack_public_path__ + "static/media/skirmishers_crossbow.babb949c.jpg";